/* Reinee Couture: WhatsApp discount offers and the help popup (sections/rc-offers.liquid).
   Works beside the WhatsApp popup (snippets/rc-whatsapp-popup.liquid) without editing it:
   - the WhatsApp popup always goes first; an offer takes a later trigger, 60s+ and a new page after it was closed
   - when an offer opens it marks the WhatsApp popup as used for this visit (rc_wa_popup_shown, rc_wa_exit_used)
   - our listeners are registered on window in the capture phase, so on the same event they run before the popup's
   Discounts are for made-to-order dresses only. No codes are made here: the stylist sends them on WhatsApp. */
(() => {
  'use strict';
  const cfgNode = document.getElementById('rc-offer-config');
  const pop = document.getElementById('rc-offer-pop');
  if (!cfgNode || !pop) return;
  let cfg;
  try { cfg = JSON.parse(cfgNode.textContent); } catch (_) { return; }

  const DAY = 864e5;
  const MIN_PAGE_MS = 5000;          // never in the first 5 seconds of a page
  const GAP_MS = 60000;              // 60s and one new page between two popups
  const RESTART_DAYS = 30;           // no WhatsApp tap 30 days after the last offer: start again
  const CHATTED_DAYS = 30;           // tapped WhatsApp in the last 30 days: no offers
  const QR_LIB = 'https://cdnjs.cloudflare.com/ajax/libs/qrcode-generator/1.4.4/qrcode.min.js';
  const STAGE1 = ['A', 'B', 'D'];

  const TEXT = {
    A: { title: 'Leaving? Get 5% off this dress on WhatsApp.', sub: "Message our stylist now and we'll send your discount code. Valid for 48 hours.",
         trust: 'Pay 50% to start your dress. Pay the remaining 50% only after you approve the finished dress on video.', button: 'Claim my 5% discount', source: 'exit_offer' },
    B: { title: 'Welcome back! Still thinking about this dress?', sub: 'Message us on WhatsApp for your 5% welcome-back discount. Valid for 48 hours.',
         trust: '2 easy payments: 50% deposit, then 50% after you see your finished dress on video.', button: 'Get my discount code', source: 'returning_offer' },
    C: { title: 'Last chance: 10% off this dress.', sub: 'Valid for 48 hours, only on WhatsApp.',
         trust: 'Start with a 50% deposit. Pay the rest only after the video approval.', button: 'Claim my 10% discount', source: 'final_offer' },
    D: { title: "Can't decide? Our stylist will help you choose.", sub: 'Send us your favourites and get a shortlist plus 5% off. Valid for 48 hours.',
         trust: 'Pay in 2 installments. Final payment only after you see your dress on video.', button: 'Send my favourites + get 5% off', source: 'favourites_offer' },
    E: { title: 'Need help choosing?', sub: "Tell our stylist about your event and she'll suggest the best dresses for you.",
         trust: 'Pay 50% to start your dress. Pay the remaining 50% only after you approve the finished dress on video.',
         trustReady: 'Ready to ship: ask about availability and delivery on WhatsApp.', button: 'Ask our stylist', source: 'help_popup' },
    small: 'Discount applies to made-to-order dresses only.'
  };

  /* ---------- Storage ---------- */
  const store = area => (key, value) => {
    try {
      const s = window[area];
      if (value === undefined) return s.getItem(key);
      if (value === null) s.removeItem(key); else s.setItem(key, value);
    } catch (_) { /* storage blocked: features fall back to doing nothing */ }
    return null;
  };
  const ss = store('sessionStorage');
  const ls = store('localStorage');
  const json = (get, key, fallback) => { try { const v = JSON.parse(get(key)); return v == null ? fallback : v; } catch (_) { return fallback; } };
  const validHandle = h => typeof h === 'string' && /^[a-z0-9][a-z0-9-]{0,200}$/.test(h);

  /* ---------- This page ---------- */
  let loadedAt = Date.now();
  const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth >= 1024;
  const device = () => { const w = window.innerWidth; return w < 768 ? 'mobile' : (w < 1024 ? 'tablet' : 'desktop'); };
  const root = (cfg.root || '/').replace(/\/?$/, '/');
  const productUrl = handle => location.origin + root + 'products/' + handle;
  let pageIndex = parseInt(ss('rc_offer_pages') || '0', 10) + 1;
  ss('rc_offer_pages', String(pageIndex));
  const visitId = ss('rc_wa_visit') || ('rc' + Date.now());

  const flags = document.querySelector('[data-rc-product-flags]');
  const product = cfg.product && flags && validHandle(cfg.product.handle)
    ? { title: cfg.product.title, handle: cfg.product.handle, image: cfg.product.image, rts: flags.dataset.rcRts === 'true' }
    : null;
  const page = cfg.page;
  // Discount offers only in made-to-order context: made-to-order dresses, collections other than Ready to Ship, homepage.
  const discountContext = page === 'index' || (page === 'collection' && !cfg.collectionRts) || (page === 'product' && product && !product.rts);
  const helpContext = page === 'index' || page === 'collection' || page === 'product';

  /* ---------- Dresses she viewed, with their Ready to Ship flag ---------- */
  let dresses = json(ls, 'rc_offer_dresses', []);
  if (!Array.isArray(dresses)) dresses = [];
  dresses = dresses.filter(d => d && validHandle(d.h));
  const earlierDresses = dresses.slice();
  if (product) {
    dresses = [{ h: product.handle, t: product.title, i: product.image, r: product.rts, ts: Date.now(), v: visitId },
      ...dresses.filter(d => d.h !== product.handle)].slice(0, 20);
    ls('rc_offer_dresses', JSON.stringify(dresses));
    const seen = json(ss, 'rc_offer_seen', []);
    if (Array.isArray(seen) && seen.indexOf(product.handle) === -1) { seen.push(product.handle); ss('rc_offer_seen', JSON.stringify(seen.slice(-60))); }
    window.addEventListener('pagehide', () => ss('rc_offer_left_dress', String(Date.now())));
  } else if (page !== 'collection') {
    ss('rc_offer_left_dress', null);
  }
  const dressPagesThisVisit = () => { const s = json(ss, 'rc_offer_seen', []); return Array.isArray(s) ? s.length : 0; };
  const mtoThisVisit = () => dresses.filter(d => !d.r && d.v === visitId);

  /* ---------- Who she is ---------- */
  const fromWhatsApp = () => {
    const q = location.search.toLowerCase();
    return ss('rc_wa_from_whatsapp') === '1' || /[?&]utm_(source|medium)=[^&]*whatsapp/.test(q) || /whatsapp/i.test(document.referrer);
  };
  const chattedRecently = () => {
    const c = json(ls, 'rc_wa_chatted', null);
    return !!(c && c.ts && Date.now() - c.ts < CHATTED_DAYS * DAY);
  };
  const tappedThisVisit = () => ss('rc_wa_clicked') === '1';
  const visit = json(ss, 'rc_visitor_v1_visit', null);
  const previousVisit = visit ? Number(visit.previous) || 0 : 0;   // kept by rc-visitor-tools; 0 = first visit

  /* ---------- Offer history (localStorage rc_offer_history: offer id, date shown, dress handle) ---------- */
  const history = () => { const h = json(ls, 'rc_offer_history', []); return Array.isArray(h) ? h.filter(e => e && e.id && e.ts) : []; };
  (() => {
    const h = history();
    if (!h.length) return;
    const c = json(ls, 'rc_wa_chatted', null);
    const tappedSinceOffers = c && c.ts >= h[0].ts;
    if (Date.now() - h[h.length - 1].ts >= RESTART_DAYS * DAY && !tappedSinceOffers) ls('rc_offer_history', null);
  })();
  const stage1 = () => history().filter(e => STAGE1.indexOf(e.id) !== -1);
  const finalShown = () => history().some(e => e.id === 'C');
  const visitIds = () => (ss('rc_offer_visit_ids') || '').split(',').filter(Boolean);

  /* ---------- Who may get which offer ---------- */
  function namedDress() {
    if (product && !product.rts) return { handle: product.handle, title: product.title, image: product.image };
    const d = mtoThisVisit()[0] || dresses.find(x => !x.r && Date.now() - x.ts < RESTART_DAYS * DAY);
    return d ? { handle: d.h, title: d.t, image: d.i } : null;
  }
  const eligible = {
    // A: first visit, 2+ made-to-order dresses viewed, no offer yet
    A() {
      if (finalShown() || stage1().length || previousVisit || visitIds().indexOf('A') !== -1) return null;
      return mtoThisVisit().length >= 2 ? namedDress() : null;
    },
    // B: returning visitor, a made-to-order dress remembered from the last 30 days
    B() {
      if (finalShown() || visitIds().indexOf('B') !== -1 || !previousVisit) return null;
      const s1 = stage1();
      if (s1.length >= 2) return null;                                       // first show + one re-show
      const since = s1.length ? s1[s1.length - 1].ts : previousVisit;
      if (Date.now() - since < cfg.returningDays * DAY) return null;
      const remembered = earlierDresses.find(d => !d.r && d.v !== visitId && Date.now() - d.ts < RESTART_DAYS * DAY);
      if (!remembered) return null;
      if (product) return product.rts ? null : { handle: product.handle, title: product.title, image: product.image };
      return { handle: remembered.h, title: remembered.t, image: remembered.i };
    },
    // C: final 10%, once: the last 5% offer was 5+ days ago and she is on that same dress again
    C() {
      if (finalShown() || !product || product.rts) return null;
      const s1 = stage1(); const last = s1[s1.length - 1];
      if (!last || Date.now() - last.ts < cfg.finalDays * DAY) return null;
      return String(last.handle || '').split(',').indexOf(product.handle) !== -1 ? { handle: product.handle, title: product.title, image: product.image } : null;
    }
  };
  // D: 2+ made-to-order dresses in favourites (read through ReineeVisitorTools; its "ready" flag means Ready to Ship)
  async function favouriteGowns() {
    const tools = window.ReineeVisitorTools;
    if (!tools || !tools.getFavourites) return [];
    const handles = tools.getFavourites().filter(validHandle).reverse().slice(0, 10);
    if (handles.length < 2) return [];
    const gowns = [];
    for (const h of handles) {
      try { const g = await tools.getGown(h); if (g && !g.ready) gowns.push(g); } catch (_) { /* unavailable: skip */ }
    }
    return gowns;
  }
  async function eligibleD() {
    if (finalShown() || visitIds().indexOf('D') !== -1) return null;
    // Normally stage 1 must still be open. With 4 popups per visit, D may also take the extra slot after A or B in this visit.
    const extraSlot = cfg.cap >= 4 && visitIds().some(id => id === 'A' || id === 'B');
    if (stage1().length && !extraSlot) return null;
    const gowns = await favouriteGowns();
    return gowns.length >= 2 ? gowns : null;
  }

  /* ---------- When a popup may open ---------- */
  const waPop = document.getElementById('rc-wa-pop');
  const waPopOpen = () => !!(waPop && !waPop.hidden);
  const otherLayerOpen = allowPanel => !!document.querySelector(
    'dialog[open]:not(#rc-offer-pop)' + (allowPanel ? ':not(#RcVisitorDialog)' : '') + ', .menu-drawer-container[open], product-modal[open], details.mobile-facets__disclosure[open]');
  let maxScrollY = window.scrollY;
  const heroBottom = () => { const hero = document.querySelector('#MainContent > .shopify-section'); return hero ? hero.getBoundingClientRect().bottom + window.scrollY : 0; };
  const browsedHome = () => page !== 'index' || pageIndex > 1 || maxScrollY > heroBottom();
  function popupsThisVisit() {
    let n = 0;
    if (ss('rc_wa_popup_shown') === '1' && ss('rc_offer_marked_popup') !== '1') n++;   // the WhatsApp popup's first show
    if (ss('rc_wa_popup_second') === '1') n++;                                          // its second show
    return n + visitIds().length;
  }
  function gapOk() {
    const last = json(ss, 'rc_offer_last_close', null);
    if (!last) return true;
    return Date.now() - last.ts >= GAP_MS && pageIndex > last.page;
  }
  // Everything except the offer's own conditions. Returns '' when it may open, else the reason.
  function blocked(id, trigger) {
    if (fromWhatsApp()) return 'from_whatsapp';
    if (chattedRecently() || tappedThisVisit()) return 'chatted';
    if (page === 'cart') return 'cart';
    if (!pop.hidden || waPopOpen() || otherLayerOpen(id === 'D')) return 'busy';
    if (Date.now() - loadedAt < MIN_PAGE_MS) return 'too_soon';
    if (!browsedHome()) return 'hero';
    const ids = visitIds();
    if (id === 'E' ? ids.length : ids.indexOf('E') !== -1) return 'help_and_offer';
    if (popupsThisVisit() >= cfg.cap) return 'cap';
    if (ids.length && !(cfg.cap >= 4 && id === 'D' && ids.length === 1)) return 'cap';   // one offer per visit; at 4 the extra slot is D only
    const exitInstead = id === 'A' && /exit|tab_return/.test(trigger);
    if (!exitInstead && ss('rc_wa_popup_shown') !== '1') return 'whatsapp_popup_first';
    if (!gapOk()) return 'gap';
    return '';
  }

  /* ---------- Tracking (same consent gate as the WhatsApp popup) ---------- */
  let current = null;   // { id, trigger, handle }
  function track(name, extra) {
    if (!window.ReineeAnalytics || !current) return;
    window.ReineeAnalytics.track(name, Object.assign({
      offer_id: current.id, device_type: device(), product_handle: current.handle || '', trigger: current.trigger, page_path: location.pathname
    }, extra || {}), true);
  }
  const eventName = (id, what) => (id === 'E' ? 'rc_help_' : 'rc_offer_') + what;

  /* ---------- Desktop QR code (copied from the WhatsApp popup so both look the same) ---------- */
  function qrSvg(text) {
    const BG = '#e8e0cf', INK = '#111';
    const qr = window.qrcode(0, 'H'); qr.addData(text); qr.make();
    const n = qr.getModuleCount(), dots = [];
    let logo = Math.ceil(n * 0.2); if ((n - logo) % 2) logo++;
    const l0 = (n - logo) / 2, l1 = l0 + logo;
    const finder = (r, c) => (r < 7 && c < 7) || (r < 7 && c >= n - 7) || (r >= n - 7 && c < 7);
    for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) {
      if (finder(r, c) || (r >= l0 && r < l1 && c >= l0 && c < l1)) continue;
      if (qr.isDark(r, c)) dots.push('<circle cx="' + (c + .5) + '" cy="' + (r + .5) + '" r=".46"/>');
    }
    const eye = (x, y) => '<rect x="' + (x + .5) + '" y="' + (y + .5) + '" width="6" height="6" rx="1.8" fill="none" stroke="' + INK + '" stroke-width="1"/>' +
      '<rect x="' + (x + 2) + '" y="' + (y + 2) + '" width="3" height="3" rx=".9" fill="' + INK + '"/>';
    const cx = n / 2, rad = logo / 2, k = rad * 1.24 / 24;
    const icon = '<circle cx="' + cx + '" cy="' + cx + '" r="' + rad + '" fill="' + BG + '"/>' +
      '<g transform="translate(' + (cx - rad * .62) + ',' + (cx - rad * .62) + ') scale(' + k + ')"><path fill="' + INK + '" d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm5.8 14.03c-.25.69-1.45 1.33-2 1.38-.53.05-1.02.24-3.44-.72-2.9-1.14-4.73-4.12-4.87-4.31-.14-.19-1.16-1.55-1.16-2.95s.74-2.09 1-2.38c.26-.28.57-.35.76-.35l.55.01c.18.01.41-.07.65.49.24.58.82 2 .89 2.15.07.14.12.31.02.5-.1.19-.14.31-.29.48-.14.17-.3.37-.43.5-.14.14-.29.29-.13.58.17.28.74 1.22 1.59 1.98 1.09.97 2.01 1.27 2.29 1.41.29.14.45.12.62-.07.17-.19.72-.84.91-1.13.19-.29.38-.24.65-.14.26.1 1.68.79 1.97.94.29.14.48.21.55.33.07.12.07.69-.18 1.38z"/></g>';
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 ' + (n + 2) + ' ' + (n + 2) + '" role="img" aria-label="WhatsApp QR code"><g fill="' + INK + '">' + dots.join('') + '</g>' + eye(0, 0) + eye(n - 7, 0) + eye(0, n - 7) + icon + '</svg>';
  }
  function showQR(text) {
    const box = pop.querySelector('[data-rc-offer-qr]');
    box.hidden = true;
    if (!isDesktop) return;
    const draw = () => { try { pop.querySelector('[data-rc-offer-qr-code]').innerHTML = qrSvg(text); box.hidden = false; } catch (_) { box.hidden = true; } };
    if (window.qrcode) return draw();
    const s = document.createElement('script'); s.src = QR_LIB; s.async = true; s.onload = draw; document.head.appendChild(s);
  }

  /* ---------- Fill and open ---------- */
  const wa = text => 'https://wa.me/' + cfg.number + '?text=' + encodeURIComponent(text);
  const q = sel => pop.querySelector(sel);
  function fill(id, data) {
    const t = TEXT[id];
    q('[data-rc-offer-title]').textContent = t.title;
    q('[data-rc-offer-sub]').textContent = t.sub;
    q('[data-rc-offer-trust]').textContent = id === 'E' && product && product.rts ? t.trustReady : t.trust;
    const small = q('[data-rc-offer-small]');
    small.textContent = id === 'E' ? '' : TEXT.small;
    small.hidden = id === 'E';
    const wrap = q('[data-rc-offer-dress]'), thumb = q('[data-rc-offer-thumb]'), thumbs = q('[data-rc-offer-thumbs]');
    wrap.hidden = true; thumb.hidden = true; thumbs.hidden = true; thumbs.replaceChildren();
    let message, qrText;
    if (id === 'D') {
      const lines = data.map(g => g.title + ' ' + productUrl(g.handle));
      message = 'Hi, here are my favourites:\n' + lines.join('\n') + "\nI'd like a shortlist and my 5% discount code.";
      qrText = "Hi, I'd like a shortlist of my favourites and my 5% discount code.";
    } else if (id === 'E') {
      const recent = dresses.slice(0, 3);
      recent.filter(d => d.i).forEach(d => {
        const img = document.createElement('img');
        img.src = d.i; img.alt = d.t || ''; img.width = 96; img.height = 128; img.loading = 'lazy'; img.decoding = 'async';
        thumbs.append(img);
      });
      thumbs.hidden = !thumbs.children.length;
      message = recent.length
        ? "Hi, I've been looking at these dresses:\n" + recent.map(d => d.t + ' ' + productUrl(d.h)).join('\n') + '\nCan you help me choose?'
        : "Hi, I've been looking at your dresses " + location.href + '. Can you help me choose?';
      qrText = 'Hi, can you help me choose a dress?';
    } else {
      const url = productUrl(data.handle);
      if (data.image) { thumb.src = data.image; thumb.alt = data.title; thumb.hidden = false; }
      q('[data-rc-offer-name]').textContent = data.title;
      wrap.hidden = false;
      const pct = id === 'C' ? '10%' : '5%';
      message = id === 'A' ? 'Hi, I was looking at ' + data.title + ' ' + url + ". I'd like my 5% discount code."
        : id === 'B' ? "Hi, I'm back and still thinking about " + data.title + ' ' + url + ". I'd like my 5% discount code."
        : "Hi, I'm ready to move forward with " + data.title + ' ' + url + ". I'd like my 10% discount code.";
      qrText = "Hi, I'd like my " + pct + ' discount code for ' + data.title + '.';
    }
    const btn = q('[data-rc-offer-btn]');
    btn.textContent = t.button;
    btn.href = wa(message);
    btn.dataset.rcWaSource = t.source;
    showQR(wa(qrText));
  }
  function open(id, trigger, data) {
    // Mark the WhatsApp popup as used for this visit, so the two never fire together.
    if (ss('rc_wa_popup_shown') !== '1') { ss('rc_wa_popup_shown', '1'); ss('rc_offer_marked_popup', '1'); }
    ss('rc_wa_exit_used', '1');
    const handle = id === 'D' ? data.map(g => g.handle).join(',') : id === 'E' ? '' : data.handle;
    if (id !== 'E') {
      const h = history(); h.push({ id, ts: Date.now(), handle }); ls('rc_offer_history', JSON.stringify(h.slice(-20)));
    }
    ss('rc_offer_visit_ids', visitIds().concat(id).join(','));
    fill(id, data);
    current = { id, trigger, handle: id === 'D' ? '' : handle };
    pop.classList.toggle('rc-wa-desk', isDesktop);
    pop.hidden = false;
    try { pop.showModal(); } catch (_) { pop.setAttribute('open', ''); }
    q('[data-rc-offer-close]').focus({ preventScroll: true });
    track(eventName(id, 'view'));
  }
  function close(how, silent) {
    if (pop.hidden) return;
    if (!silent) track(eventName(current.id, 'close'), { method: how });
    try { pop.close(); } catch (_) { pop.removeAttribute('open'); }
    pop.hidden = true;
    popupClosed();
  }
  q('[data-rc-offer-close]').addEventListener('click', () => close('x_button'));
  pop.addEventListener('cancel', e => { e.preventDefault(); close('esc'); });
  pop.addEventListener('click', e => {
    if (e.target !== pop) return;
    const r = pop.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close('overlay');
  });
  q('[data-rc-offer-btn]').addEventListener('click', () => {
    ss('rc_wa_clicked', '1');
    track(eventName(current.id, 'whatsapp_click'), { link_url: q('[data-rc-offer-btn]').href });
    setTimeout(() => close('whatsapp', true), 300);
  });

  /* ---------- After any big popup closes: remember when (60s gap), glow the teaser at 60s and 150s ---------- */
  const GLOWS = [60000, 150000];
  let glowTimers = [];
  function scheduleGlow() {
    glowTimers.forEach(clearTimeout); glowTimers = [];
    const from = parseInt(ss('rc_offer_glow_from') || '0', 10);
    if (!cfg.glow || !from) return;
    GLOWS.forEach(after => {
      const wait = from + after - Date.now();
      if (wait <= 0) return;
      glowTimers.push(setTimeout(() => {
        const teaser = document.getElementById('rc-wa-teaser');
        if (!teaser || teaser.hidden || !pop.hidden || waPopOpen()) return;
        teaser.classList.remove('rc-wa-nudge'); void teaser.offsetWidth; teaser.classList.add('rc-wa-nudge');
      }, wait));
    });
  }
  function popupClosed() {
    ss('rc_offer_last_close', JSON.stringify({ ts: Date.now(), page: pageIndex }));
    ss('rc_offer_glow_from', String(Date.now()));
    scheduleGlow();
  }
  if (waPop) {
    let wasOpen = waPopOpen();
    new MutationObserver(() => { const now = waPopOpen(); if (wasOpen && !now) popupClosed(); wasOpen = now; })
      .observe(waPop, { attributes: true, attributeFilter: ['hidden'] });
  }
  scheduleGlow();

  /* ---------- Pick and open an offer for a trigger ---------- */
  const offersOn = () => cfg.offers && discountContext;
  let busy = false;
  // Synchronous for A, B and C, so an exit offer can claim the exit before the WhatsApp popup's listener runs.
  function tryOffers(trigger, ids) {
    if (!offersOn() || busy || !pop.hidden) return false;
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      // D needs the saved dresses' details first; the remaining offers are tried if D cannot open.
      if (id === 'D') { tryFavourites(trigger, ids.slice(i + 1)); return false; }
      const data = eligible[id]();
      if (data && !blocked(id, trigger)) { open(id, trigger, data); return true; }
    }
    return false;
  }
  async function tryFavourites(trigger, rest) {
    if (busy) return;
    let gowns = null;
    if (!blocked('D', trigger)) {
      busy = true;
      try { gowns = await eligibleD(); } finally { busy = false; }
    }
    if (gowns && !blocked('D', trigger)) open('D', trigger, gowns);
    else if (rest.length) tryOffers(trigger, rest);
  }
  // Timed triggers that are only held back by the 60s gap try again once the gap has passed (same page).
  function tryLater(trigger, ids) {
    if (tryOffers(trigger, ids)) return;
    const last = json(ss, 'rc_offer_last_close', null);
    if (!last || pageIndex <= last.page) return;
    const wait = last.ts + GAP_MS - Date.now();
    if (wait > 0 && wait < 120000) setTimeout(() => tryOffers(trigger, ids), wait + 50);
  }
  const atFiveSeconds = fn => setTimeout(fn, Math.max(0, loadedAt + MIN_PAGE_MS - Date.now()));
  const generic = page === 'product' ? ['B', 'D'] : page === 'index' ? ['B', 'D'] : ['B'];

  /* Dress page: 5s after load (C, else B). Same moment covers "2nd dress page". 30 seconds on the page. */
  if (product) {
    atFiveSeconds(() => tryLater(dressPagesThisVisit() >= 2 ? 'product_views_2' : 'page_load_5s', ['C', 'B']));
    setTimeout(() => tryOffers('product_time_30s', generic), 30000);
  }

  /* Homepage and collections: 25% scroll (B; D on the homepage too) */
  if (page === 'index' || page === 'collection') {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max < 0.25) return;
      window.removeEventListener('scroll', onScroll);
      atFiveSeconds(() => tryOffers('scroll_25', page === 'index' ? ['B', 'D'] : ['B']));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Back from a dress (collections) */
  if (page === 'collection') {
    const backFromDress = () => {
      const left = parseInt(ss('rc_offer_left_dress') || '0', 10);
      ss('rc_offer_left_dress', null);
      if (left && Date.now() - left < 30 * 60000) atFiveSeconds(() => tryOffers('back_from_dress', generic));
    };
    backFromDress();
    window.addEventListener('pageshow', e => { if (e.persisted) { loadedAt = Date.now(); pageIndex++; ss('rc_offer_pages', String(pageIndex)); backFromDress(); } });
  }

  /* Exit intent. Exit candidates: B on the homepage and collections, then A. */
  const exitIds = page === 'product' ? ['A'] : ['B', 'A'];
  if (isDesktop) {
    // Desktop: the mouse leaves the top of the page after 5+ seconds. Capture on window runs before the popup's listener.
    window.addEventListener('mouseout', e => {
      if (e.relatedTarget || e.clientY > 10 || Date.now() - loadedAt < MIN_PAGE_MS) return;
      tryOffers('exit_intent', exitIds);
    }, true);
  } else {
    // Phone: a fast scroll back up after reading (800px+, then 350px up within 600ms, not in the first 10s, 25%+ scrolled).
    let maxY = 0, lastY = null, lastT = Date.now(), upStartY = null, upStartT = 0, lastFlick = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY, t = Date.now();
      if (y > maxY) maxY = y;
      if (lastY === null) { lastY = y; lastT = t; return; }
      // The flick starts at the last position, but its clock starts now: after a pause to read, lastT is seconds old.
      if (y < lastY) { if (upStartY === null) { upStartY = lastY; upStartT = Math.max(lastT, t - 100); } } else upStartY = null;
      lastY = y; lastT = t;
      if (upStartY === null) return;
      if (maxY < 800 || upStartY - y < 350 || t - upStartT > 600) return;
      if (t - loadedAt < MIN_PAGE_MS * 2) return;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0 || maxY / max < 0.25) return;
      upStartY = null;
      const repeat = t - lastFlick < 60000; lastFlick = t;
      if (repeat) return;                                   // more than one flick in 60 seconds: ignore
      tryOffers('scroll_up_exit', exitIds);
    }, { passive: true, capture: true });
    // Phone: the tab is hidden (after 5s and 25% scroll); the offer shows when she comes back.
    let hiddenExit = false;
    document.addEventListener('visibilitychange', () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (document.hidden) { hiddenExit = Date.now() - loadedAt >= MIN_PAGE_MS && max > 0 && maxScrollY / max >= 0.25; return; }
      if (hiddenExit) { hiddenExit = false; setTimeout(() => tryOffers('tab_return', exitIds), 600); }
    });
  }
  window.addEventListener('scroll', () => { if (window.scrollY > maxScrollY) maxScrollY = window.scrollY; }, { passive: true });

  /* Favourites panel opened from the header heart: D */
  window.addEventListener('click', e => {
    if (!e.target.closest) return;
    if (e.target.closest('[data-rc-open="favourites"]')) setTimeout(() => tryOffers('favourites_panel', ['D']), 1200);
    // Heart saved (anywhere): D first, else B
    const heart = e.target.closest('[data-rc-save]');
    if (heart) setTimeout(() => { if (heart.getAttribute('aria-pressed') === 'true') tryOffers('saved_dress', ['D'].concat(generic.filter(x => x !== 'D'))); }, 1200);
  }, true);

  /* Dress page buying signals (same as the WhatsApp popup): size guide, size picked, 4+ photos swiped, 2 zooms */
  if (product) {
    let signalled = false;
    const signal = (name, delay) => { if (signalled) return; signalled = true; setTimeout(() => tryOffers(name, generic), delay); };
    let guideTimer = null;
    window.addEventListener('toggle', e => {
      const d = e.target;
      if (!d || d.tagName !== 'DETAILS') return;
      const sum = d.querySelector('summary');
      if (!sum || !/size\s*guide|size\s*chart/i.test(sum.textContent)) return;
      if (d.open) guideTimer = setTimeout(() => signal('size_guide', 0), 15000);
      else { clearTimeout(guideTimer); signal('size_guide', 800); }
    }, true);
    window.addEventListener('change', e => {
      const el = e.target; if (!el || !el.closest) return;
      const fs = el.closest('fieldset'), lg = fs && fs.querySelector('legend');
      const label = (el.name || '') + ' ' + (lg ? lg.textContent : '');
      if (el.closest('variant-selects, variant-radios, .product-form__input') && /size|taille|المقاس|مقاس/i.test(label)) signal('size_selected', 2000);
    }, true);
    const slides = document.querySelectorAll('.product__media-list > li');
    if (!isDesktop && 'IntersectionObserver' in window && slides.length >= 4) {
      const seen = new Set();
      const io = new IntersectionObserver(entries => {
        entries.forEach(en => { if (en.intersectionRatio >= 0.6) seen.add(en.target); });
        if (seen.size >= 4) { io.disconnect(); signal('photos_viewed_4', 1500); }
      }, { threshold: [0.6] });
      slides.forEach(li => io.observe(li));
    }
    let zooms = 0;
    window.addEventListener('click', e => { if (e.target.closest && e.target.closest('.product__modal-opener') && ++zooms >= 2) signal('photo_zoom', 2500); }, true);
  }

  /* ---------- E: help popup (no discount) ---------- */
  async function discountPossible() {
    if (!offersOn()) return false;
    if (eligible.A() || eligible.B() || eligible.C()) return true;
    return !!(await eligibleD());
  }
  let helpTimer = null;
  async function tryHelp(trigger) {
    clearTimeout(helpTimer);
    if (!cfg.help || !helpContext || ss('rc_offer_help_shown') === '1' || visitIds().length) return;
    const due = parseInt(ss('rc_offer_help_due') || '0', 10) + MIN_PAGE_MS;
    const reason = Date.now() < due ? 'too_soon' : blocked('E', trigger);
    if (reason === 'too_soon' || reason === 'busy' || reason === 'gap' || reason === 'hero' || reason === 'whatsapp_popup_first') {
      helpTimer = setTimeout(() => tryHelp(trigger), Math.max(MIN_PAGE_MS, due - Date.now()));
      return;
    }
    if (reason || await discountPossible() || blocked('E', trigger)) return;
    ss('rc_offer_help_shown', '1');
    open('E', trigger, null);
  }
  function helpReached(trigger) {
    if (!ss('rc_offer_help_due')) ss('rc_offer_help_due', String(Date.now()));
    ss('rc_offer_help_trigger', trigger);
    tryHelp(trigger);
  }
  if (cfg.help && helpContext && ss('rc_offer_help_shown') !== '1') {
    if (ss('rc_offer_help_due')) tryHelp(ss('rc_offer_help_trigger') || 'resume');
    else if (dressPagesThisVisit() >= cfg.helpPages) helpReached('dress_pages_' + cfg.helpPages);
    // Dress cards scrolled past: counted when at least half visible, unique by handle, kept for the visit.
    const grid = document.getElementById('product-grid');
    if (grid && 'IntersectionObserver' in window && !ss('rc_offer_help_due')) {
      const cards = new Set(json(ss, 'rc_offer_cards_seen', []).filter(validHandle));
      const watched = new WeakSet();
      let saveTimer = null;
      const io = new IntersectionObserver(entries => {
        entries.forEach(en => {
          if (en.intersectionRatio < 0.5) return;
          const h = en.target.dataset.rcHandle;
          if (validHandle(h)) cards.add(h);
          io.unobserve(en.target);
        });
        clearTimeout(saveTimer);
        saveTimer = setTimeout(() => ss('rc_offer_cards_seen', JSON.stringify([...cards].slice(-400))), 300);
        if (cards.size >= cfg.helpCards && !ss('rc_offer_help_due')) { io.disconnect(); mo.disconnect(); helpReached('cards_seen_' + cfg.helpCards); }
      }, { threshold: [0.5] });
      const scan = () => document.querySelectorAll('#product-grid > li[data-rc-handle]').forEach(li => { if (!watched.has(li)) { watched.add(li); io.observe(li); } });
      // New cards from endless loading, and the grid replaced by filters or sorting (facets.js).
      let queued = false;
      const mo = new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; scan(); }); });
      mo.observe(document.getElementById('ProductGridContainer') || grid.parentElement, { childList: true, subtree: true });
      scan();
    }
  }
})();
